import { useState, useMemo, useCallback } from 'react'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { SentimentWidgetsType } from 'components/widget/SentimentWidgets/types'
import useWidgetSettingComposingStrategy from './useWidgetSettingComposingStrategy'
import useSearchFilterComposingStrategy from './useSearchFilterComposingStrategy'
import { addSelectionFilterToWidgetSetting, convertToInsightContentSetting } from '../utils'

const useSelectedInsights = (widgetSetting: SentimentWidgetsType) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedInsights, setSelectedInsights] = useState<InsightData[]>([])

  const searchFilterComposingStrategy = useSearchFilterComposingStrategy(widgetSetting.viewOption!)
  const widgetSettingComposingStrategy = useWidgetSettingComposingStrategy(
    widgetSetting.viewOption!
  )

  const detailSetting = useMemo(
    () =>
      convertToInsightContentSetting(widgetSetting, searchFilterComposingStrategy, {
        insights: selectedInsights
      }),
    [searchFilterComposingStrategy, widgetSetting, selectedInsights]
  )

  const widgetSettingWithSelection = useMemo(
    () =>
      addSelectionFilterToWidgetSetting(widgetSetting, widgetSettingComposingStrategy, {
        insights: selectedInsights
      }),
    [widgetSettingComposingStrategy, widgetSetting, selectedInsights]
  )

  const onClick = useCallback(
    (insightData: InsightData) => {
      setIsModalOpen(true)
      setSelectedInsights([insightData])
    },
    [setIsModalOpen, setSelectedInsights]
  )

  const onClose = useCallback(() => {
    setIsModalOpen(false)
    setSelectedInsights([])
  }, [setIsModalOpen, setSelectedInsights])

  return {
    isModalOpen,
    selectedInsights,
    detailSetting,
    widgetSettingWithSelection,
    onClick,
    onClose
  }
}

export default useSelectedInsights
